import { render, staticRenderFns } from "./ProductsFormComponent.vue?vue&type=template&id=326612dc&scoped=true&"
import script from "./ProductsFormComponent.vue?vue&type=script&lang=js&"
export * from "./ProductsFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductsFormComponent.vue?vue&type=style&index=0&id=326612dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326612dc",
  null
  
)

export default component.exports